<template>
  <div class="vch-ordering-options">
    <div class="vch-ordering-options__details-row">
      <div class="vch-ordering-options__product-img" v-if="productInfo">
        <img :src="productInfo.ProductImage" :alt="productInfo.ProductName" />
      </div>
      <div class="vch-ordering-options__options">
        <div class="mt-lg product-info">
          <!-- <span class="product-info__label heading-xxs bg-liftactiv mb-xs">
            Neu</span
          > -->
          <h2 class="product-info__name" v-if="productInfo">
            <span class="vch-ordering-options__productTitle">
              {{ productInfo.ProductName }}
            </span>
            <span class="vch-ordering-options__productSubTitle">
              {{ productInfo.SubTitle }}
            </span>
          </h2>
        </div>
        <div class="vch-ordering-options__titles">
          <p class="heading-xl">{{ thirdTitle }}</p>
          <p class="heading-xxs mt-xs">{{ thirdDescription }}</p>
        </div>
        <div class="vch-ordering-options__retailer-row mt-xxs">
          <div class="vch-ordering-options__local">
            <h3 class="heading-xs-em">
              {{ clickCollectTitle }}
            </h3>
            <h4 class="heading-xxs mt-xs mb-xs">
              {{ clickCollectDescription }}
            </h4>
            <a
              :href="clickCollectUrl"
              :aria-label="clickCollectLabel"
              @click="buyStep2Event"
              target="_blank"
              class="button -primary mb-xs"
              ><span class="button__label">{{ clickCollectLabel }}</span></a
            >
            <span
              v-if="!clickCollectUrl"
              class="vch-ordering-options__error text-small"
              >{{ clickandCollectWarningMessage }}</span
            >
          </div>
          <div class="vch-ordering-options__online">
            <h3 class="heading-xs-em">{{ commerceTitle }}</h3>
            <h4 class="heading-xxs mt-xxs">{{ commerceDescription }}</h4>
            <div
              class="vch-retailers__slider mb-xs"
              v-if="productInfo.Varients.length !== 0"
              style="z-index: 0 !important"
            >
              <vch-scroller
                style="opacity: 1; top: 24px; z-index: 0 !important">
                <vch-retailers-item-list
                  :slider-display="true"
                  apiEndpoint=""
                  :product-id="productInfo.ProductId"
                >
                  <ul class="vch-slider__list mb-xs" v-if="shops.length !== 0">
                    <li class="vch-slider__item" v-for="shop in shops">
                      <a
                        class="retailer__wrapper"
                        :href="shop.Link"
                        target="_blank"
                        @click="datapushevents(shop)"
                        v-vch-tagging:buyclick="{
                          data: '',
                        }"
                      >
                        <div class="retailer__logo">
                          <img :src="shop.Logo" :alt="shop.Title" />
                        </div>
                      </a>
                    </li>
                  </ul>
                  <span v-else class="vch-ordering-options__error text-small">{{
                    commerceWarningMessage
                  }}</span>
                </vch-retailers-item-list>
              </vch-scroller>
            </div>
            <div v-else class="vch-ordering-options__error text-small">
              {{ commerceWarningMessage }}
            </div>
          </div>
        </div>
        <hr style="opacity: 0.2" />
        <div class="vch-ordering-options__retailer-row">
          <div class="vch-ordering-options__local">
            <span>
              <h3 class="heading-xs-em">
                {{ pharmacyTitle }}
                <div class="tooltip">
                  <svg
                    style="display: inline-block"
                    aria-hidden="true"
                    width="14"
                    height="14"
                  >
                    <use href="/assets/sprite/icons.svg#info-icon"></use>
                  </svg>
                  <span class="tooltiptext heading-xxs">{{
                    iconHelperText
                  }}</span>
                </div>
              </h3>
            </span>
          </div>
          <div class="vch-ordering-options__online">
            <a
              :href="pharmacyPageLink"
              :aria-label="findPharmacyCTALabel"
              @click="dataEventsPharmacy()"
              target="_blank"
              class="button -secondary find-a-pharmacy-tag"
              ><span class="button__label find-a-pharmacy-tag">{{
                findPharmacyCTALabel
              }}</span></a
            >
          </div>
        </div>
        <hr style="opacity: 0.2" />
      </div>
    </div>
  </div>
</template>

<script>
import { pushData } from 'Utils/datalayer';
export default {
  name: 'vch-cc-modal-ordering-options',
  components: {},
  data() {
    return {
      shops: [],
      selectedvariantId: '',
      clickCollectUrl: '',
    };
  },
  props: {
    productInfo: {
      type: Object,
      required: true,
    },
    thirdTitle: {
      type: String,
      required: true,
    },
    thirdDescription: {
      type: String,
      required: true,
    },
    pharmacyTitle: {
      type: String,
      required: true,
    },
    pharmacyDescription: {
      type: String,
      required: true,
    },
    commerceTitle: {
      type: String,
      required: true,
    },
    commerceDescription: {
      type: String,
      required: true,
    },
    clickCollectLabel: {
      type: String,
      required: true,
    },
    clickCollectTitle: {
      type: String,
      required: true,
    },
    clickCollectDescription: {
      type: String,
      required: true,
    },
    selectedCountry: {
      type: String,
      required: true,
    },
    currentVariantId: {
      type: String,
      required: true,
    },
    findPharmacyCTALabel: {
      type: String,
      required: true,
    },
    pharmacyPageLink: {
      type: String,
      required: true,
    },
    clickandCollectWarningMessage: {
      type: String,
      required: true,
    },
    commerceWarningMessage: {
      type: String,
      required: true,
    },
    iconHelperText: {
      type: String,
      required: true,
    },
    productItemId: {
      type: String,
    },
    varintItemId: {
      type: String,
    },
  },
  computed: {
    selectedvariantId: function () {
      return this.currentVariantId;
    },
  },
  mounted() {
    this.handleOrderingData();
  },
  updated() {
    this.handleOrderingData();
  },
  methods: {
    handleOrderingData() {
      let selectedVariant;
      let countryName = this.selectedCountry;
      if (this.productInfo && this.productInfo.Varients.length == 1) {
        selectedVariant = this.productInfo.Varients[0];
        if (selectedVariant && selectedVariant.ClickCollectUrls) {
          this.clickCollectUrl = selectedVariant.ClickCollectUrls[countryName];
        }
      } else {
        selectedVariant = this.productInfo.Varients.find(
          (varient) => varient.Ean == this.currentVariantId
        );
        if (selectedVariant && selectedVariant.ClickCollectUrls) {
          this.clickCollectUrl = selectedVariant.ClickCollectUrls[countryName];
        }
      }
      if (selectedVariant) {
        this.shops = selectedVariant.Countrie.find(
          (country) => country.CountryName == countryName
        ).Shops;
      }
    },
    datapushevents(data) {
      const clickData = data.Tagging.click;
      let ecommerce = JSON.parse(JSON.stringify(clickData.ecommerce));
      let urlParams = new URLSearchParams(window.location.search);
      let dimension91Data;
      if (urlParams.has('prescripted')) {
        dimension91Data = urlParams.get('prescripted');
        ecommerce.add.products[0].dimension91 = dimension91Data;
      }
      pushData({
        ecommerce: ecommerce,
        event: `${clickData.event}`,
        eventAction: `${clickData.eventAction}`,
        eventCategory: `${clickData.eventCategory}`,
        eventLabel: `${clickData.eventLabel}`,
        event_name: `${clickData.event_name}`,
        product_info: `${clickData.product_info}`,
        step: `${clickData.step}`,
        store_name: `${clickData.store_name}`,
      });
    },
    buyStep2Event() {
      const varientData = this.productInfo.Varients;
      let varientName = '';
      let varientQuantity = '';
      let dimension91Data;
      // Check if the desired value is present in the query string
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('prescripted')) {
        dimension91Data = urlParams.get('prescripted');
      }
      varientData.forEach((element) => {
        if (element.Ean == this.currentVariantId) {
          varientName = element.ShadeName;
          varientQuantity = element.CommerceConnectorVariantName;
        }
      });
      pushData({
        event: 'addToCart',
        event_name: 'add_to_cart',
        eventCategory: 'Ecommerce',
        eventAction: 'redirection::vichy',
        eventLabel: this.productInfo.ProductName
          ? this.productInfo.ProductName.toLowerCase()
          : this.productInfo.SubTitle.toLowerCase() +
            '::' +
            this.currentVariantId,
        product_info: this.productInfo.ProductName
          ? this.productInfo.ProductName.toLowerCase()
          : this.productInfo.SubTitle.toLowerCase() +
            '::' +
            this.currentVariantId,
        step: 'redirection',
        store_name: 'vichy',
        ecommerce: {
          add: {
            actionField: '',
            products: [
              {
                name: this.productInfo.ProductName
                  ? this.productInfo.ProductName.toLowerCase()
                  : this.productInfo.SubTitle.toLowerCase(),
                id: this.currentVariantId,
                price: 'none',
                brand:
                  this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                  this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                    .click.ecommerce.add.products[0].brand
                    ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                        .click.ecommerce.add.products[0].brand
                    : 'VIC',
                category:
                  this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                  this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                    .click.ecommerce.add.products[0].category
                    ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                        .click.ecommerce.add.products[0].category
                    : 'hair care',
                variant: this.productInfo.SubTitle.toLowerCase(),
                quantity:
                  this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                  this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                    .click.ecommerce.add.products[0].quantity
                    ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                        .click.ecommerce.add.products[0].quantity
                    : 'none',
                dimension35: varientQuantity
                  ? varientQuantity.toLowerCase()
                  : 'none',
                dimension36:
                  this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                  this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                    .click.ecommerce.add.products[0].dimension36
                    ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging.click.ecommerce.add.products[0].dimension36.toLowerCase()
                    : 'none',
                dimension38:
                  this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                  this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                    .click.ecommerce.add.products[0].dimension38
                    ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                        .click.ecommerce.add.products[0].dimension38
                    : '0',
                dimension48: this.currentVariantId,
                dimension59:
                  this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                  this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                    .click.ecommerce.add.products[0].dimension59
                    ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                        .click.ecommerce.add.products[0].dimension59
                    : '0',
                dimension91: dimension91Data
                  ? dimension91Data
                  : this.productInfo.Varients[0].Countrie[0].Shops[0] &&
                    this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                      .click.ecommerce.add.products[0].dimension91
                  ? this.productInfo.Varients[0].Countrie[0].Shops[0].Tagging
                      .click.ecommerce.add.products[0].dimension91
                  : 'none',
              },
            ],
          },
        },
      });
    },
    dataEventsPharmacy() {
      /*const varientData = this.productInfo.Varients;
      let varientName = '';
      varientData.forEach((element) => {
        if (element.Ean == this.currentVariantId) {
          varientName = element.ShadeName;
        }
      });
      pushData({
        event: 'uaevent',
        event_name: 'where_to_buy',
        ecommerce: 'undefined',
        eventCategory: 'where to shop',
        eventAction: 'click to buy::select::' + this.selectedCountry,
        eventLabel: this.selectedCountry + '::' + this.pharmacyPageLink,
        product_info: this.productInfo.ProductName
          ? this.productInfo.ProductName
          : this.productInfo.SubTitle +
            '::' +
            this.currentVariantId +
            this.productInfo.Varients[0].DeclaredContent
          ? this.productInfo.Varients[0].DeclaredContent +
            this.productInfo.Varients[0].DeclaredContentUnit
          : varientName,
        store_name: 'undefined',
      }); */
    },
  },
};
</script>

<style lang="scss" src="./cc-modal-ordering-options.scss"></style>
